import React from 'react';

import { DeviceUtil } from '../util';

interface HookState
  extends Readonly<{
    isTouchInputSupported: boolean;
  }> {}

const createState = (): HookState => {
  const state: HookState = {
    isTouchInputSupported: DeviceUtil.isTouchInputSupported(),
  };

  return state;
};

export const useDeviceInfo = () => {
  const [state] = React.useState<HookState>(() => createState());

  return state;
};
